export const COMPANY_NAME = 'by IMITI, Arllecta Inc';
export const COMPANY_ADDRESS = '919 North Market Street, Wilmington, Delaware, 19801';
